import Home from './components/Home.vue';


export default
 [
  {path: '/', component:Home},
]



// WEBPACK FOOTER //
// ./src/routes.js